<div
  [ngClass]="{
    'order-entry__panel-strategy__container': 'true',
    'gammacustom': true,
    'edit': isEditEnabled
  }"
>
  <!-- SEPARATING APPARATUS -->
  <hr class="oe__panel-actions__hr" />
  <div class="gamma-viewer__customize-bar">
    <div class="gamma-viewer__start-space"></div>
    <div *ngIf="isEditEnabled" class="gamma-viewer__customize-details">
      <div class="gamma-viewer__cell">
        <bfx-amount-spinner
          #customAmount
          [externalState]="0"
          [showValidationBar]="true"
          [(ngModel)]="gammaTopLeg.amount"
          [keyupAssignZero]="false"
          [disabled]="false"
          [dead]="false"
          [size]="'sm'"
        >
        </bfx-amount-spinner>
      </div>
      <div class="gamma-viewer__cell">
        <ic-price-spinner
          #customRate
          [(ngModel)]="rate"
          [disabled]="false"
          [showValidationBar]="true"
          [productCode]="ccyPair ? ccyPair.product : null"
          [inverted]="ccyPair ? ccyPair.inverted : null"
          [size]="'sm'"
        ></ic-price-spinner>
      </div>
      <!--div style="width: 100px;">

      </div-->
      <bfx-icon-button
        class="add-leg-button"
        tabindex="-1"
        size="sm"
        iconClass="icon_ion_add_circle_filled"
        (action)="addLeg(rowData)"
        title="Add Leg"
      ></bfx-icon-button>
    </div>

    <button
      pButton
      type="button"
      fxFlex="100px"
      class="bfx-button-secondary-bold"
      (click)="submit()"
      [label]="activeButtonLabel"
      [style.margin-left]="'auto'"
      [disabled]="!data.permissions.submit || !customiseButtonEnabled"
    ></button>
  </div>
</div>
